import React, { useContext } from 'react';
import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { AppContext } from '../context';
import { getOrganization } from 'views/App/Portal/LexID/Organizations/_data_sources/useOrganization';
import { Box, CircularProgress } from '@mui/material';
import { Organization } from 'views/App/Portal/LexID/Organizations/_types/organization';
import AuthUtil from 'utils/AuthUtil';

export default function SwitchOrganization() {
  const { currentProfile, updatePermissions, setPollForPermissionChanges } = useContext(AppContext);
  const { id } = useParams();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let newId: string = id || '';
  if (newId.length === 0 && currentProfile?.user?.orgId) {
    newId = currentProfile.user?.orgId;
  }
  if (!id || id === '') {
    if (AuthUtil.shouldAllowStorageOperations()) {
      localStorage.setItem('phx-currentOrganizationId', newId?.toString());
      localStorage.setItem('phx-currentOrganizationName', '');
    }
    return <Navigate to={searchParams.get('redir') || '/admin/lexid/organizations'} />;
  } else {
    getOrganization(newId).then((org: Organization) => {
      if (org) {
        if (AuthUtil.shouldAllowStorageOperations()) {
          localStorage.setItem('phx-currentOrganizationId', newId?.toString());
          localStorage.setItem('phx-currentOrganizationName', org?.organization?.name || '');
        }
        updatePermissions(
          org.organization?.id,
          (org?.organization?.authorizations || []).map((x) => x.action)
        );
        setPollForPermissionChanges(true);
        navigate(searchParams.get('redir') || '/admin/dashboard');
      } else {
        navigate('/admin/dashboard');
      }
    });
  }

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '40vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
}
